import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AppButton, Box, FormProvider, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';
import { HealthPlanRenewal, RenewalDeductibleConfig } from '@/modules/Renewals/renewals.types';

import { EditAmountsFormValues } from '../EditAmountsModal.types';

import CoverageLevelsSection from './CoverageLevelsSection';
import TiersSection from './TiersSection';

interface Props {
  visible: boolean;
  healthPlan: HealthPlanRenewal;
  planYearDates: string;
  methods: UseFormReturn<EditAmountsFormValues>;
  onClose: () => void;
  onSave: () => void;
  originalDeductibleConfigs?: RenewalDeductibleConfig[];
}

const TEST_ID = 'edit-amounts-modal';

const EditAmountsModal: React.FC<Props> = ({
  visible,
  healthPlan,
  planYearDates,
  methods,
  onClose,
  onSave,
  originalDeductibleConfigs,
}) => {
  return (
    <Modal visible={visible} onSetVisible={onClose}>
      <FormProvider {...methods}>
        <Box data-testid={TEST_ID} direction="column" gap="spacing24">
          {/* Header */}
          <Box direction="row" align="center" justify="center">
            <Text size="2xl" color="textTitle" weight="bold">
              Edit Amounts for {healthPlan.name}
            </Text>
          </Box>

          {/* Plan year dates */}
          <Box direction="row" justify="between" align="center">
            <Text color="textBody">First and last date of plan year:</Text>
            <Text color="textBody" weight={700}>
              {planYearDates}
            </Text>
          </Box>

          {/* Tiers Section */}
          <TiersSection
            tiers={healthPlan.processingTiers || []}
            deductibleConfigs={healthPlan.deductibleConfigs}
            testId={TEST_ID}
          />

          {/* Coverage Levels Section (includes Plans inside each coverage) */}
          <CoverageLevelsSection
            configs={healthPlan.deductibleConfigs || []}
            originalConfigs={originalDeductibleConfigs}
            testId={TEST_ID}
          />

          {/* Actions */}
          <Box direction="row" align="center" justify="end" gap="s">
            <AppButton
              testId={`${TEST_ID}_cancel-button`}
              buttonType="secondary"
              width="control"
              onClick={onClose}
            >
              Cancel
            </AppButton>
            <AppButton testId={`${TEST_ID}_save-button`} width="control" onClick={onSave}>
              Save
            </AppButton>
          </Box>
        </Box>
      </FormProvider>
    </Modal>
  );
};

export default EditAmountsModal;
